import { graphql } from "api/cms-website/generated";

export const HalfTextAndImageBannerFragment = graphql(/* GraphQL */ `
    fragment HalfTextAndImageBannerFragment on ComponentComponentsHalfTextAndImageBanner {
        id
        noMarginBottom
        HalfTextAndImageBannerTitle: title
        HalfTextAndImageBannerSubtitle: subtitle
        HalfTextAndImageBannerImage: image {
            ...ResponsiveImageFragment
        }
    }
`);
